import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule} from '@angular/forms'; 
import { RouterModule } from '@angular/router';
import { TestReportListComponent } from './testreportlist/testreportlist.component';
import { PatientSearchComponent } from './patientsearch/patientsearch.component';
import { MyPatientsComponent } from './mypatients/mypatients.component';
import { OrderSearchComponent } from './ordersearch/ordersearch.component';
import { TestSummaryComponent } from './testsummary/testsummary.component';
import { NgxPaginationModule } from 'ngx-pagination'; 

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgxPaginationModule
  ],
  declarations: [TestReportListComponent, PatientSearchComponent, MyPatientsComponent, OrderSearchComponent, TestSummaryComponent],
})
export class ReportingModule { }
